import { Injectable, inject } from '@angular/core';
import { NgrxHttpClient } from '@library/utils/services/http-service';
import {
  ChangePolarityPayload,
  GetMinHeatingTimePayload,
  MinHeatingTimeResponse,
  ModuleRoomUpdate,
  RemoveDataGatewayPayload,
  RemoveModulePayload,
  SetMinHeatingTimePayload,
  TransferMeasurementsPayload,
} from './modules.interface';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable()
export class ModulesService {
  protected http = inject(NgrxHttpClient);

  changePolarity(params: ChangePolarityPayload) {
    return this.http.post('changedevicebehavior', params);
  }

  updateModule(params, header?: Record<string, string>) {
    return this.http.post('updatemodule', params, null, null, header);
  }

  updateDevice(params) {
    return this.http.post('updatedevice', params);
  }

  updateModuleRoom(params: ModuleRoomUpdate, header?: Record<string, string>) {
    return this.http.post('assigndevicetoroom', params, null, null, header);
  }

  removeDeviceFromHome(params: RemoveModulePayload) {
    return this.http.post('removedevicefromhome', params);
  }

  removeDataGateway(params: RemoveDataGatewayPayload) {
    return this.http.post('removedata', params);
  }

  transferModuleMeasurements(params: TransferMeasurementsPayload) {
    return this.http.post('transfermeasurements', params);
  }
  setMinHeatingTime(params: SetMinHeatingTimePayload) {
    return this.http.post('thermoregulation/v1/setMinHeatingTime', params, environment.baseApiUrl);
  }

  getMinHeatingTime(params: GetMinHeatingTimePayload) {
    return this.http.get<MinHeatingTimeResponse>('thermoregulation/v1/minHeatingTime', params, environment.baseApiUrl);
  }
}
